import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';

class ConservazioneVersamentoResultController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices
    ) {
        $scope.pageHeader = 'Esito';
        $scope.pageSubHeader = 'Riepilogo';

        let result = store.get('ConservazioneVersamento-Result');
        if (result === undefined) {
            $state.go('home.home-index');
        }
        $scope.result = result;
        $scope.next = () => {
            store.remove('ConservazioneVersamento-Result');
            $state.go('home.conservazione');
        };
    }
}

export const ConservazioneVersamentoResultComponent: ng.IComponentOptions = {
    template: require('./conservazione-versamento-result.html'),
    controller: ConservazioneVersamentoResultController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-versamento-result/conservazione-versamento-result.ts